import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import "./About.css";

const About = () => {
  const [imageRef, imageVisible] = useScrollAnimation();
  const [contentRef, contentVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section id="intro" className="about">
      <div className="about-container">
        <div ref={imageRef} className={`about-image-container ${imageVisible ? "animate-in" : ""}`}>
          <img
            src="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&h=600&fit=crop"
            alt="Financial advisor working with client"
            className="about-image"
          />
        </div>
        <div ref={contentRef} className={`about-content ${contentVisible ? "animate-in" : ""}`}>
          <h2 className="about-headline">About BSquare Financial: The Clarity Standard</h2>
          <h3 className="about-subheadline">The BSquare Origin: Why We Exist</h3>
          <p className="about-body">
            Bsquare Financial was founded to bridge a growing gap in the Ontario financial landscape. For too long, families and professionals have been treated as "transactions," particularly during high-stress moments like mortgage renewals or business expansions.
          </p>
          <p className="about-body">
            We understand that as financial obligations grow—mortgages renew, practices expand, and families evolve—insurance strategies that were once "good enough" often become obsolete or inefficient. Our mission is to move away from the "pushy sales" model and toward a Data-First Protection Audit that puts the client back in control.
          </p>
          <p className="about-body">
            Our role is to help clients understand their current structures, identify gaps or inefficiencies, and make informed decisions aligned with their present circumstances and long-term objectives.
          </p>
          <p className="about-approach">
            We believe effective financial protection planning is built on <strong>clarity, timing, and suitability.</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
